import * as Yup from 'yup'

export const validation = {
    grupo_academia_id: Yup.string().typeError('El id de la academia debe ser tipo texto'),
    comentario_profesor_ap: Yup.string().typeError('Los comentarios deben ser tipo texto'),
    comentarios_generales: Yup.string().typeError('Los comentarios deben ser tipo texto'),
}

export const validationSchema = Yup.object().shape(validation)